import React from 'react';

const Pill = ({ rot, begin, shouldGrow }) => (
  <rect
    x="2"
    y="220"
    width="636"
    height="200"
    rx="105"
    transform={`rotate(${rot},320,320)`}
    vectorEffect="non-scaling-stroke"
    strokeWidth="1"
  >
    <animateTransform
      begin={begin}
      calcMode="spline"
      keySplines="0 0 1 1; 0.85 0 0.15 1"
      attributeName="transform"
      attributeType="XML"
      type="rotate"
      values={`${rot} 320 320;${rot} 320 320;${rot + 360} 320 320`}
      dur="10s"
      repeatCount="indefinite"
    />
    {shouldGrow && (
      <>
        <animate
          attributeName="x"
          values="2;220;2"
          dur="10s"
          repeatCount="indefinite"
          calcMode="spline"
          keySplines="0.85 0 0.15 1; 0.85 0 0.15 1"
        />
        <animate
          attributeName="width"
          values="636;200;636"
          dur="10s"
          repeatCount="indefinite"
          calcMode="spline"
          keySplines="0.85 0 0.15 1; 0.85 0 0.15 1"
        />
      </>
    )}
  </rect>
);

const GrayGradient = () => (
  <linearGradient
    x1="0%"
    y1="0%"
    x2="100%"
    y2="100%"
    id="welcomeGuideGrayGrad"
    gradientUnits="userSpaceOnUse"
  >
    <stop stopColor="#FBFCFD" stopOpacity="0.5" offset="0%"></stop>
    <stop stopColor="#7B7B7B" offset="100%"></stop>
  </linearGradient>
);

const ColorGradient = () => (
  <linearGradient x1="20%" y1="0" x2="80%" y2="100%" id="welcomeGuideColorGrad">
    <stop stopColor="#FEC99B" stopOpacity="0.86" offset="0%"></stop>
    <stop stopColor="#FF8992" stopOpacity="0.86" offset="40%"></stop>
    <stop stopColor="#FF677D" stopOpacity="0.86" offset="60%"></stop>
    <stop stopColor="#36B4FE" stopOpacity="0.86" offset="80%"></stop>
    <stop stopColor="#0373B0" stopOpacity="0.86" offset="100%"></stop>
  </linearGradient>
);

export default function Graphic({ className, variant = 'gray' }) {
  let Gradient = GrayGradient;
  let gradientID = 'welcomeGuideGrayGrad';
  let shouldGrow = false;

  if (variant != 'gray') {
    Gradient = ColorGradient;
    gradientID = 'welcomeGuideColorGrad';
    shouldGrow = true;
  }

  return (
    <svg className={className} viewBox="0 0 640 640">
      <defs>
        <Gradient />
        <rect id="pill" x="2" y="220" width="636" height="200" rx="105" />
      </defs>
      <g stroke={`url(#${gradientID})`} fill="none">
        <Pill shouldGrow={shouldGrow} rot={157.5} begin="-1.4s" />
        <Pill shouldGrow={shouldGrow} rot={135} begin="-1.2s" />
        <Pill shouldGrow={shouldGrow} rot={112.5} begin="-1s" />
        <Pill shouldGrow={shouldGrow} rot={90} begin="-0.8s" />
        <Pill shouldGrow={shouldGrow} rot={67.5} begin="-0.6s" />
        <Pill shouldGrow={shouldGrow} rot={45} begin="-0.4s" />
        <Pill shouldGrow={shouldGrow} rot={22.5} begin="-0.2s" />
        <Pill shouldGrow={shouldGrow} rot={0} begin="0" />
      </g>
    </svg>
  );
}
